import React from 'react';
import Icon, { IconProps } from './Icon';

const ArrowNarrowUpIcon: React.FC<IconProps> = ({ size = 24, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M12 20V4M12 4L6 10M12 4L18 10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default ArrowNarrowUpIcon;

